import React, { useState } from 'react';
import { Typography, TextField, Button, CircularProgress, Paper, useMediaQuery, InputAdornment, IconButton } from "@material-ui/core";
//import { useNotify } from "react-admin";
import config from './config.json';
import { customTheme } from "./customTheme";
import md5 from 'md5';
import { passwordSalt } from "./sharedData";
import VisibilityIcon from '@material-ui/icons/Visibility';
import VisibilityOffIcon from '@material-ui/icons/VisibilityOff';
import notify from './components/CustomUseNotify';

export default function Payment(props) {
    //const notify = useNotify();
    const isSmallDevice = useMediaQuery(theme => customTheme.breakpoints.down("xs"));

    const [currentPassword, setCurrentPassword] = useState("");
    const [showCurrentPassword, setShowCurrentPassword] = useState(false);
    const [newPassword, setNewPassword] = useState("");
    const [showNewPassword, setShowNewPassword] = useState(false);
    const [confirmPassword, setConfirmPassword] = useState("");
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const [loading, setLoading] = useState(false);

    const updatePassword = () => {
        if (currentPassword == null || currentPassword === "") {
            notify("Current Password cannot be empty", "warning");
            return;
        }
        if (newPassword == null || newPassword === "") {
            notify("New Password cannot be empty", "warning");
            return;
        }
        if (confirmPassword !== newPassword) {
            notify("Confirm Password does not match New Password", "warning");
            return;
        }

        setLoading(true);
        const data = {
            user_id: sessionStorage.getItem("user_id"),
            current_password: md5(currentPassword + passwordSalt),
            new_password: md5(newPassword + passwordSalt)
        };
        const token = sessionStorage.getItem('token');
        fetch(`${config.HOST_NAME}/crm/v3/crmUsers/updatePassword`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`
            },
            body: JSON.stringify(data)
        })
            .then(response => response.json())
            .then(json => {
                setLoading(false);
                notify(json.message, json.success ? "success" : "warning");
                if (json.success) {
                    setCurrentPassword("");
                    setNewPassword("");
                    setConfirmPassword("");
                }
            })
            .catch((error) => {
                setLoading(false);
                notify(error, "warning");
            });
    };

    return (
        <Paper style={{ padding: isSmallDevice ? "0 22px 25px" : "25px 22px", boxShadow: isSmallDevice ? "none" : undefined }}>
            <div style={{ borderBottom: "1px solid #ddd", alignItems: "center", paddingBottom: 15, marginBottom: 20, textAlign: "center" }}>
                <Typography>Change Password</Typography>
            </div>
            <div>
                <TextField
                    className='changePasswordTextField'
                    type={showCurrentPassword ? "text" : "password"}
                    variant="outlined"
                    size="small"
                    label="Current Password"
                    value={currentPassword}
                    onChange={event => setCurrentPassword(event.target.value)}
                    style={{ display: "block", marginBottom: 20 }}
                    InputProps={{
                        endAdornment: <InputAdornment position="end">
                            <IconButton
                                onClick={() => setShowCurrentPassword(!showCurrentPassword)}
                                edge="end"
                            >
                                {showCurrentPassword ? <VisibilityIcon /> : <VisibilityOffIcon />}
                            </IconButton>
                        </InputAdornment>
                    }}
                />
                <TextField
                    className='changePasswordTextField'
                    type={showNewPassword ? "text" : "password"}
                    variant="outlined"
                    size="small"
                    label="New Password"
                    value={newPassword}
                    onChange={event => setNewPassword(event.target.value)}
                    style={{ display: "block", marginBottom: 20 }}
                    InputProps={{
                        endAdornment: <InputAdornment position="end">
                            <IconButton
                                onClick={() => setShowNewPassword(!showNewPassword)}
                                edge="end"
                            >
                                {showNewPassword ? <VisibilityIcon /> : <VisibilityOffIcon />}
                            </IconButton>
                        </InputAdornment>
                    }}
                />
                <TextField
                    className='changePasswordTextField'
                    type={showConfirmPassword ? "text" : "password"}
                    variant="outlined"
                    size="small"
                    label="Confirm Password"
                    value={confirmPassword}
                    onChange={event => setConfirmPassword(event.target.value)}
                    style={{ display: "block", marginBottom: 20 }}
                    InputProps={{
                        endAdornment: <InputAdornment position="end">
                            <IconButton
                                onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                                edge="end"
                            >
                                {showConfirmPassword ? <VisibilityIcon /> : <VisibilityOffIcon />}
                            </IconButton>
                        </InputAdornment>
                    }}
                />
                <Button
                    variant="contained"
                    color="primary"
                    onClick={updatePassword}
                    disabled={currentPassword === "" || newPassword === "" || confirmPassword === "" || loading}
                    style={{ textTransform: "none" }}
                >
                    {loading ? "Updating..." : "Update"}
                    {loading && <CircularProgress color="inherit" size={14} style={{ marginLeft: 15 }} />}
                </Button>
            </div>
        </Paper>
    );
}